module.exports = __webpack_public_path__ + "static/media/conference.ab61a42b.png";